/**
 *
 * EmptyStateAmbassador
 *
 */

import React from "react"
import { Divider, Empty, Progress } from "antd"
import empty_reports_home from "images/empty_reports_home.svg"
import { get } from "lodash"
import { MEASURE_STATUS } from "../../../../../utils/constants"
import { loadTexts, sanitize } from "../../../../../utils/i18n"

const EmptyStateAmbassador = ({
  measureEngagement,
  measureTotal,
  measureGeneral,
  userType,
}) => {
  const intlEmptyStateAmbassador = loadTexts("reports_general_view").reportAdmin.emptyStateAmbassador
  const engagementOrClimate = measureGeneral.is_engagement
    ? measureEngagement
    : measureTotal
  return (
    <div style={{ padding: "1rem 2rem 2rem" }}>
      {[
        MEASURE_STATUS.in_progress.id_measure_status,
        MEASURE_STATUS.finished.id_measure_status,
      ].includes(get(measureGeneral, "id_measure_status", 0)) &&
      !get(userType, "is_empty", true) ? (
        <Empty
          style={{ color: "#828282" }}
          image={
            <div className="ReportHome__response-rate">
              <div className="ReportHome__response-rate__title">
                {intlEmptyStateAmbassador.responseRate}
              </div>
              <div>
                <div
                  className="ReportHome__response-rate__number"
                  style={{
                    color: engagementOrClimate.rate.rate_color,
                  }}>
                  {engagementOrClimate.rate.rate_visible}
                </div>
                <div className="ReportHome__response-rate__collaboratos">
                  {get(engagementOrClimate, "employees", 0)}/
                  {get(engagementOrClimate, "recipients", 0)} {intlEmptyStateAmbassador.employees}
                </div>
                <Progress
                  percent={engagementOrClimate.rate.rate}
                  showInfo={false}
                  strokeColor={engagementOrClimate.rate.rate_color}
                />
              </div>
            </div>
          }
          description={
            <span
              style={{
                margin: "24px auto 0",
                maxWidth: 620,
                display: "block",
              }}>
              <span style={{ fontWeight: 600, fontSize: 16, display: "block" }}>
                {intlEmptyStateAmbassador.noResults}
                {measureGeneral.id_survey_type === 2 ? intlEmptyStateAmbassador.team : intlEmptyStateAmbassador.division}{" "}
                {intlEmptyStateAmbassador.yet}
              </span>
              <span style={{ marginTop: 10, display: "block" }}>
                <div>{intlEmptyStateAmbassador.measureInProgress}</div>
                <div className="ReportHome__response-rate__dates">
                  {get(measureGeneral, "name", "")}
                  <div style={{ marginTop: 8 }}>
                    <b>{intlEmptyStateAmbassador.startDate}</b> {get(measureGeneral, "date_start", "")}{" "}
                    <Divider type="vertical" />
                    <b>{intlEmptyStateAmbassador.endDate}</b> {get(measureGeneral, "date_end", "")}
                  </div>
                </div>
                <div>
                  {sanitize(intlEmptyStateAmbassador.body)}
                  {measureGeneral.id_survey_type === 2
                    ? "."
                    : intlEmptyStateAmbassador.actionplans}
                </div>
              </span>
            </span>
          }
          className="ReportHome-empty-fix"
        />
      ) : (
        <Empty
          style={{ color: "#828282" }}
          image={empty_reports_home}
          description={
            <span
              style={{
                margin: "24px auto 0",
                maxWidth: 480,
                display: "block",
              }}>
              <span style={{ fontWeight: 600, fontSize: 16, display: "block" }}>
                <div>
                  {get(userType, "isInMeasure", true) &&
                  !get(userType, "anonymity_check", false)
                    ? "¡Tu división no cuenta con resultados!"
                    : "¡No cuentas con resultados recientes!"}
                </div>
              </span>
              <span style={{ marginTop: 10, display: "block" }}>
                <div>
                  {get(userType, "isInMeasure", true) &&
                  !get(userType, "anonymity_check", false) ? (
                    <div>
                       Parece que la división de la que has sido asignado como
                      embajador no cuenta con resultados debido a que no se ha
                      superado el mínimo de anonimato para las respuestas.

                    </div>
                  ) : (
                    <div>
                     No cuentas con ninguna medición reciente o en curso con
                      resultados. Acércate al área de Gestión del Talento para
                      conocer cuando será la próxima medición.
                    </div>
                  )}
                </div>
              </span>
            </span>
          }
          className="ReportHome-empty-fix"
        />
      )}
    </div>
  )
}

EmptyStateAmbassador.defaultProps = { count: 1 }

export default EmptyStateAmbassador
